// extracted by mini-css-extract-plugin
export default {"wrap":"DisclosureTriangle_wrap__jgDH7"};